import { T } from 'gt-react';
import { ArchiveIcon } from '@phosphor-icons/react';
import { Button } from 'src/components/ui/button';

/** Archive (TaskType delete) and Save, shown to TaskType editors. */
export function TaskTypeDetailActions({
  canArchive,
  archiveDisabled,
  saveDisabled,
  isSaving,
  onArchive,
  onSave,
}: {
  canArchive: boolean;
  archiveDisabled: boolean;
  saveDisabled: boolean;
  isSaving: boolean;
  onArchive: () => void;
  onSave: () => void;
}) {
  return (
    <div className="flex items-center gap-2">
      {canArchive && (
        <Button
          variant="ghost"
          size="sm"
          disabled={archiveDisabled}
          onClick={onArchive}
        >
          <ArchiveIcon className="size-3.5" />
          <T context="button, archive this task type">Archive</T>
        </Button>
      )}
      <Button size="sm" disabled={saveDisabled} onClick={onSave}>
        {isSaving ? (
          <T context="button label while saving a task type">Saving…</T>
        ) : (
          <T context="button, save the task type">Save</T>
        )}
      </Button>
    </div>
  );
}
